import React, { useEffect, useState } from "react";
import { getConfigValues } from "../../Helpers/APIEndPoints/EndPoints";
import { APICall } from "../../Helpers/Network/APICalls";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";

const LoanModuleHomePage = () => {
  const [loanDescription, setLoanDescription] = useState("");
  const [loanBenefit, setLoanBenefit] = useState("");
  const { showLoader, hideLoader } = React.useContext(LoaderContext);

  useEffect(() => {
    callGetConfigData();
  }, []);

  const callGetConfigData = async () => {
    showLoader();
    const params = ["LoanDescription", "LoanBenefit"];

    const configdata = await APICall(getConfigValues, { Keys: params });

    if (configdata.Message == "Ok" && configdata.Data.length > 0) {
      configdata.Data.map((cd) => {
        if (cd.Key === "LoanDescription") {
          setLoanDescription(formatText(cd.Value));
          // setLoanDescription(cd.Value);
        }
        if (cd.Key === "LoanBenefit") {
           setLoanBenefit(cd.Value);
        }
      });
    }
    hideLoader();
  };

     // Helper function to replace '@' with '>' and new lines with <br />
     const formatText = (text) => {
      return text
        .replace(/@/g, "&#8226;")       // Replace '@' with '>'
        .replace(/\n/g, "<br />"); // Replace new lines with <br />
    };
  

  return (
    <div>
      <h3 className="text-center text-danger font-weight-bold mb-2">
        Loan Description
      </h3>
      <div
        className="form-group p-4 border border-danger"
        style={{ borderRadius: 20 }}
      >
        <h4 className="text-center font-weight-bold">Description</h4>
        <p dangerouslySetInnerHTML={{ __html: loanDescription }} 
        // style={{ marginLeft: "200px", marginRight: "200px" }} 
        // style={{ textAlign: "center" }} 
        />
        {/* <div>{loanDescription}</div> */}
        <h4 className="text-center mt-3 font-weight-bold">Benefits</h4>
        <div>{loanBenefit}</div>
      </div>
    </div>
  );
};

export default LoanModuleHomePage;
